import { render } from "./AggressiveGraph.vue?vue&type=template&id=2b685152&scoped=true"
import script from "./AggressiveGraph.vue?vue&type=script&lang=js"
export * from "./AggressiveGraph.vue?vue&type=script&lang=js"

import "./AggressiveGraph.vue?vue&type=style&index=0&id=2b685152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b685152"]])

export default __exports__